export const IMAGES = {
  logo: process.env.PUBLIC_URL + "/hantry2.jpg",
  noError: process.env.PUBLIC_URL + "/NoError.png",
  React: process.env.PUBLIC_URL + "/React.png",
  Vue: process.env.PUBLIC_URL + "/Vue.png",
  JavaScript: process.env.PUBLIC_URL + "/JavaScript.png",
  Node: process.env.PUBLIC_URL + "/Node.png",
  Angular: process.env.PUBLIC_URL + "/Angular.png",
  ReactLogo: process.env.PUBLIC_URL + "/reactLogo.PNG",
};
